import React from 'react'

import { IoIosClose } from "react-icons/io";
import { IoLogInOutline } from "react-icons/io5";
import { FiTrendingUp, FiInfo, FiGift } from "react-icons/fi";
import { Link } from 'react-router-dom';


const MobileMenu = ({closeMobileMenu, translateAction}) => {

  return (

        <div className ={`fixed p-4 top-0 left-0 bg-mainBackColor w-full h-full flex flex-col items-start justify-start space-y-[5rem] z-50 transition-all duration-[250ms] ${translateAction}`}>

              <div className='relative flex justify-between items-center min-h-[4rem] w-full'>
                    <Link to = '/' className="relative flex justify-start items-center h-full shrink-0">
                        <span className="font-logo font-[700] text-[18px] tracking-tight text-white">Zenit<span className="text-userDashPurple">chain</span></span>
                    </Link>

                    <button onClick={() => closeMobileMenu()}>
                        <IoIosClose className='text-white font-[550] text-[34px]' />
                    </button>
              </div>

              <div className="relative w-full flex flex-col justify-start items-start">
                    <ul className="relative w-full flex flex-col justify-start items-start space-y-[4rem]">
                        <li>
                            <Link to="/Signin" className="flex items-center space-x-3 text-white font-[500] text-[15.5px]">
                                <FiTrendingUp className="text-primaryGreen text-[20px]" />
                                <span>Trade</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/about" className="flex items-center space-x-3 text-white font-[500] text-[15.5px]">
                                <FiInfo className="text-primaryGreen text-[20px]" />
                                <span>About</span>
                            </Link>
                        </li>
                        <li>
                            <Link to="/airdrops" className="flex items-center space-x-3 text-white font-[500] text-[15.5px]">
                                <FiGift className="text-primaryGreen text-[20px]" />
                                <span>Airdrops</span>
                            </Link>
                        </li>

                        <li>
                            <Link to="/signin" className="w-[120px] h-[45px] border border-primaryGreen flex justify-center items-center rounded space-x-2 transition-all hover:bg-primaryGreen/10">
                                <IoLogInOutline className='text-primaryGreen text-[16.5px]'/>
                                <p className="text-[14.5px] text-primaryGreen">Sign in</p>
                            </Link>
                        </li>
                    </ul>
              </div>

        </div>


  )
}

export default MobileMenu
